import { render, staticRenderFns } from "./search.vue?vue&type=template&id=263ca02a&scoped=true&"
import script from "./search.vue?vue&type=script&lang=ts&"
export * from "./search.vue?vue&type=script&lang=ts&"
import style0 from "./search.vue?vue&type=style&index=0&id=263ca02a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263ca02a",
  null
  
)

component.options.__file = "search.vue"
export default component.exports